import * as yup from 'yup';
import { EMAIL_LIST_ITEM_VALUES } from './emailListItems';

export const EMAIL_PROCESS_OPTIONS = [
    { value: 'Uw', label: 'Uw' },
    { value: 'Confirmation_uw', label: 'Confirmation_uw' },
    { value: 'Claims', label: 'Claims' },
    { value: 'Uw + Confirmation_uw', label: 'Uw + Confirmation_uw' },
    { value: 'Confirmation_uw + Claims', label: 'Confirmation_uw + Claims' },
    { value: 'All', label: 'All' },
    { value: 'Manual', label: 'Manual' },
];

export const EMAIL_PROCESS_VALUES = EMAIL_PROCESS_OPTIONS.map((opt) => opt.value);

export const RECIPIENT_TYPE_OPTIONS = [
    { value: 'client', label: 'Client' },
    { value: 'admin', label: 'Admin' },
];

export const EMAIL_MANAGEMENT_TYPE = {
    STANDARD: 'standard',
    SPECIFIQUE: 'specifique',
};

export const EMAIL_MANAGEMENT_TYPE_OPTIONS = [
    { value: EMAIL_MANAGEMENT_TYPE.STANDARD, label: 'Standard' },
    { value: EMAIL_MANAGEMENT_TYPE.SPECIFIQUE, label: 'Spécifique' },
];

export const EMAIL_MANAGEMENT_CONFIG_DEFAULTS = {
    email_management_type: EMAIL_MANAGEMENT_TYPE.STANDARD,
    email_process: '',
    recipient_type: 'client',
    email_list: [],
};

export const inferEmailManagementType = (emailMgmt) => {
    const list = Array.isArray(emailMgmt?.email_list)
        ? emailMgmt.email_list.filter((item) => item != null && String(item).trim() !== '')
        : [];
    if (list.length > 0) return EMAIL_MANAGEMENT_TYPE.STANDARD;
    if (emailMgmt?.email_process) return EMAIL_MANAGEMENT_TYPE.SPECIFIQUE;
    return EMAIL_MANAGEMENT_TYPE.STANDARD;
};

export const getEmailManagementConfigSchema = () => yup.object().shape({
    email_management_type: yup
        .string()
        .transform((value) => value || undefined)
        .required('Email Management est requis')
        .oneOf(
            [EMAIL_MANAGEMENT_TYPE.STANDARD, EMAIL_MANAGEMENT_TYPE.SPECIFIQUE],
            'Email Management doit être Standard ou Spécifique'
        ),
    email_process: yup.string().when('email_management_type', {
        is: EMAIL_MANAGEMENT_TYPE.SPECIFIQUE,
        then: (schema) => schema
            .transform((value) => value || undefined)
            .required('Le processus email est requis')
            .oneOf(EMAIL_PROCESS_VALUES, 'Le processus email doit être une valeur valide'),
        otherwise: (schema) => schema.optional().nullable(),
    }),
    recipient_type: yup
        .string()
        .oneOf(['client', 'admin'], 'Le type de destinataire doit être client ou admin')
        .required('Le destinataire est requis'),
    email_list: yup.array().when('email_management_type', {
        is: EMAIL_MANAGEMENT_TYPE.STANDARD,
        then: (schema) => schema
            .of(yup.string().oneOf(EMAIL_LIST_ITEM_VALUES, 'Code e-mail Standard invalide'))
            .min(1, 'Sélectionnez au moins un email')
            .required('La liste des e-mails autorisés est requise'),
        otherwise: (schema) => schema.optional().nullable(),
    }),
});

export const applyEmailManagementTypeChange = (setValue, value) => {
    setValue('email_management_type', value, { shouldDirty: true, shouldValidate: true });
    if (value === EMAIL_MANAGEMENT_TYPE.STANDARD) {
        setValue('email_process', '', { shouldDirty: true, shouldValidate: true });
        return;
    }
    setValue('email_list', [], { shouldDirty: true, shouldValidate: true });
};

export const buildEmailManagementPayload = (data) => {
    const payload = {};

    if (data.recipient_type) {
        payload.recipient_type = data.recipient_type;
    }

    if (data.email_management_type === EMAIL_MANAGEMENT_TYPE.STANDARD) {
        payload.email_list = Array.isArray(data.email_list) ? data.email_list : [];
        return payload;
    }

    if (data.email_management_type === EMAIL_MANAGEMENT_TYPE.SPECIFIQUE) {
        payload.email_process = data.email_process;
        payload.email_list = [];
        return payload;
    }

    return payload;
};
